/**
 * Minimal ISO-3166 alpha-2 catalog used by the shop UI for country
 * dropdowns and badges. A subset focused on jurisdictions vendors
 * actually ship from / to.
 */

export interface CountryEntry {
  iso2: string;
  name: string;
  flag: string;
}

export const COUNTRIES: ReadonlyArray<CountryEntry> = [
  { iso2: 'US', name: 'United States',    flag: '\uD83C\uDDFA\uD83C\uDDF8' },
  { iso2: 'CA', name: 'Canada',           flag: '\uD83C\uDDE8\uD83C\uDDE6' },
  { iso2: 'MX', name: 'Mexico',           flag: '\uD83C\uDDF2\uD83C\uDDFD' },
  { iso2: 'GB', name: 'United Kingdom',   flag: '\uD83C\uDDEC\uD83C\uDDE7' },
  { iso2: 'IE', name: 'Ireland',          flag: '\uD83C\uDDEE\uD83C\uDDEA' },
  { iso2: 'DE', name: 'Germany',          flag: '\uD83C\uDDE9\uD83C\uDDEA' },
  { iso2: 'FR', name: 'France',           flag: '\uD83C\uDDEB\uD83C\uDDF7' },
  { iso2: 'ES', name: 'Spain',            flag: '\uD83C\uDDEA\uD83C\uDDF8' },
  { iso2: 'IT', name: 'Italy',            flag: '\uD83C\uDDEE\uD83C\uDDF9' },
  { iso2: 'NL', name: 'Netherlands',      flag: '\uD83C\uDDF3\uD83C\uDDF1' },
  { iso2: 'CH', name: 'Switzerland',      flag: '\uD83C\uDDE8\uD83C\uDDED' },
  { iso2: 'PL', name: 'Poland',           flag: '\uD83C\uDDF5\uD83C\uDDF1' },
  { iso2: 'CN', name: 'China',            flag: '\uD83C\uDDE8\uD83C\uDDF3' },
  { iso2: 'HK', name: 'Hong Kong',        flag: '\uD83C\uDDED\uD83C\uDDF0' },
  { iso2: 'TW', name: 'Taiwan',           flag: '\uD83C\uDDF9\uD83C\uDDFC' },
  { iso2: 'JP', name: 'Japan',            flag: '\uD83C\uDDEF\uD83C\uDDF5' },
  { iso2: 'KR', name: 'South Korea',      flag: '\uD83C\uDDF0\uD83C\uDDF7' },
  { iso2: 'IN', name: 'India',            flag: '\uD83C\uDDEE\uD83C\uDDF3' },
  { iso2: 'SG', name: 'Singapore',        flag: '\uD83C\uDDF8\uD83C\uDDEC' },
  { iso2: 'AU', name: 'Australia',        flag: '\uD83C\uDDE6\uD83C\uDDFA' },
  { iso2: 'NZ', name: 'New Zealand',      flag: '\uD83C\uDDF3\uD83C\uDDFF' },
  { iso2: 'AE', name: 'United Arab Emirates', flag: '\uD83C\uDDE6\uD83C\uDDEA' },
  { iso2: 'TH', name: 'Thailand',         flag: '\uD83C\uDDF9\uD83C\uDDED' },
  { iso2: 'TR', name: 'Turkey',           flag: '\uD83C\uDDF9\uD83C\uDDF7' },
  { iso2: 'BR', name: 'Brazil',           flag: '\uD83C\uDDE7\uD83C\uDDF7' },
];

const BY_ISO: Map<string, CountryEntry> = new Map(COUNTRIES.map((c) => [c.iso2, c]));

export function countryByIso(iso2: string | null | undefined): CountryEntry | null {
  if (!iso2) return null;
  return BY_ISO.get(iso2.toUpperCase()) ?? null;
}

export function countryName(iso2: string | null | undefined): string {
  return countryByIso(iso2)?.name ?? (iso2 ?? '');
}
